
import { RentalMethod } from "@/api/dtos/RentalMethod.schema";
import { Device } from "@/api/dtos/Station.schema";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import AddDeviceUserDialog from "../dialogs/AddDeviceUserDialog.vue";
import EditButton from "../buttons/EditButton.vue";
import CancelButton from "../buttons/CancelButton.vue";
import DangerButton from "../buttons/DangerButton.vue";
import EditFrame from "../EditFrame.vue";

@Component({
  components: {
    EditFrame,
    AddDeviceUserDialog,
    EditButton,
    CancelButton,
    DangerButton,
  },
})
export default class RentalMethodForm extends Vue {
  @Prop()
  device!: Device;
  @Prop()
  stationId!: string;

  @Prop({
    default: false,
  })
  hideControls!: boolean;
  @Prop({ default: false }) editMode!: boolean;

  editedRentalMethod: RentalMethod | null = null;
  showUserDialog = false;

  mounted(): void {
    this.importData();
  }

  @Watch("device.rentalMethod", { immediate: false })
  onRentalMethodChanged(newVal: RentalMethod, oldVal: RentalMethod): void {
    if (newVal !== oldVal) {
      this.importData();
    }
  }

  importData(): void {
    this.editedRentalMethod = this.device.rentalMethod ?? "PRIVATE";
  }

  get rentalMethodSelectItems(): {
    text: string;
    value: RentalMethod;
  }[] {
    return [
      {
        text: "Öffentlich",
        value: "PUBLIC",
      },
      {
        text: "Privat",
        value: "PRIVATE",
      },
      {
        text: "Exklusiv",
        value: "EXCLUSIVE",
      },
    ];
  }

  onInput(value: RentalMethod): void {
    this.editedRentalMethod = value;
    this.$nextTick(() => {
      this.$emit("input", value);
    });
  }
}
